import styled, { css } from 'styled-components';
import { TestButton as Btn } from './TestButton';

export const ButtonContainer = styled.div<{
  $largeScreenLayout: 'grid' | 'column';
  $onVideo?: boolean;
}>(
  ({ $largeScreenLayout, $onVideo, theme }) => css`
    display: grid;
    gap: ${$onVideo ? theme.sz.s2 : theme.sz.s3};
    grid-template-columns: 1fr;

    @media (min-width: ${({ theme }) => theme.sz.ml}) {
      gap: ${$onVideo ? theme.sz.s3 : theme.sz.s4};
    }

    ${
      $largeScreenLayout === 'grid' &&
      `
      @media (min-width: 30rem) {
        grid-template-columns: 1fr 1fr;
      }
    `
    };
  `,
);

export const Button = styled(Btn)<{
  $showBigger: boolean;
  $onVideo?: boolean;
}>(
  ({ theme, $showBigger, $onVideo }) => css`
    button {
      font-size: ${
        $showBigger
          ? `clamp(${theme.DEPRECATED_ty.larger}, 2.5vw, ${theme.DEPRECATED_ty.largest})`
          : `clamp(${theme.DEPRECATED_ty.medium}, 2.5vw, ${theme.DEPRECATED_ty.larger})`
      };
      padding-top: clamp(
        ${$onVideo ? theme.DEPRECATED_ty.small : theme.DEPRECATED_ty.medium},
        2.5vw,
        ${$onVideo ? theme.DEPRECATED_ty.medium : theme.DEPRECATED_ty.larger}
      );
      padding-bottom: clamp(
        ${$onVideo ? theme.DEPRECATED_ty.small : theme.DEPRECATED_ty.medium},
        2.5vw,
        ${$onVideo ? theme.DEPRECATED_ty.medium : theme.DEPRECATED_ty.larger}
      );
      height: 100%;
      border-radius: ${theme.bo.medium};
      font-weight: ${theme.DEPRECATED_ty.semiBold};
      -webkit-font-smoothing: 'antialiased';

      &:hover:focus-visible {
        // same as global override
        box-shadow: 0 0 0 3px ${theme.co.information50};
      }
    }
  `,
);

export const Image = styled.img`
  max-height: 200px;
  max-width: 200px;
  object-fit: contain;
  width: 100%;
`;
